const styles = {
  link: 'text-body1 text-red-medium tesn:text-esn-primary tesn:hover:text-esn-primary-light teair:text-air-coral teair:hover:text-air-coral-light underline hover:text-red font-semibold',
};

export default styles;
